import { Routes, UrlSegment, UrlMatchResult } from '@angular/router';
import { RoutePaths } from './core/constants/routes';
import { NewRoofCostPageComponent } from './modules/new-roof-cost/components/new-roof-cost-page/new-roof-cost-page.component';
import { CompanyEstimatorPageComponent } from './modules/company-estimator/components/company-estimator-page/company-estimator-page.component';
import {
  FIND_ROOFERS_ROUTE_PATTERN,
  ROOF_SCAN_ROUTE_PATTERN,
  convertUrlStateToStateName,
} from './constants/routes';
import { stateExists } from './constants/leads-landing-pages.constant';

function leadsLandingPagesMatcher(
  segments: UrlSegment[]
): UrlMatchResult | null {
  if (segments.length !== 1) {
    return null;
  }

  const path = `/${segments[0].path}`;

  let stateName: string | null = null;

  const findRoofersMatch = path.match(FIND_ROOFERS_ROUTE_PATTERN);
  if (findRoofersMatch) {
    stateName = findRoofersMatch[1];
  } else {
    const roofScanMatch = path.match(ROOF_SCAN_ROUTE_PATTERN);
    if (roofScanMatch) {
      stateName = convertUrlStateToStateName(roofScanMatch[1]);
    }
  }

  if (!stateName || !stateExists(stateName)) {
    return null;
  }

  return {
    consumed: segments,
    posParams: {
      stateName: new UrlSegment(stateName, {}),
    },
  };
}

export const routes: Routes = [
  {
    path: 'find-roofers',
    loadChildren: () =>
      import('./modules/traffic/traffic.module').then(c => c.TrafficModule)
  },
  {
    path: 'roof-scan',
    loadChildren: () =>
      import('./modules/traffic/traffic.module').then(c => c.TrafficModule)
  },
  {
    path: 'roof-quote',
    loadChildren: () =>
      import('./modules/traffic/traffic.module').then(c => c.TrafficModule)
  },
  {
    matcher: leadsLandingPagesMatcher,
    loadChildren: () =>
      import('./modules/traffic/traffic.module').then(c => c.TrafficModule)
  },
  {
    path: RoutePaths.HOME,
    loadChildren: () =>
      import('./modules/lead-generation/lead-generation.module').then(c => c.LeadGenerationModule)
  },
  {
    path: RoutePaths.SIDING,
    loadChildren: () =>
      import('./modules/siding/siding.module').then(c => c.SidingModule)
  },
  {
    path: RoutePaths.NEWS,
    loadChildren: () =>
      import('./modules/news/news.module').then(c => c.NewsModule)
  },
  {
    path: RoutePaths.CONTACT,
    loadChildren: () =>
      import('./modules/contact/contact.module').then(c => c.ContactModule)
  },
  {
    path: RoutePaths.FAQ,
    loadChildren: () =>
      import('./modules/faq/faq.module').then(c => c.FaqModule)
  },
  {
    path: RoutePaths.QUESTIONNAIRE,
    loadChildren: () =>
      import('./modules/questionnaire/questionnaire.module').then(
        c => c.QuestionnaireModule
      )
  },
  {
    path: RoutePaths.QUESTIONS_AND_CONSIDERATIONS,
    loadChildren: () =>
      import(
        './modules/questions-and-considerations/questions-and-considerations.module'
        ).then(c => c.QuestionsAndConsiderationsModule)
  },
  {
    path: RoutePaths.QUOTE_GENERATOR,
    loadChildren: () =>
      import(
        './modules/quote-generator/quote-generator-routing.module'
        ).then(c => c.QuoteGeneratorRoutingModule)
  },
  {
    path: RoutePaths.COOKIE_POLICY,
    loadChildren: () =>
      import('./modules/cookie-policy/cookie-policy.module').then(
        c => c.CookiePolicyModule
      )
  },
  {
    path: RoutePaths.PRIVACY_POLICY,
    loadChildren: () =>
      import('./modules/privacy-policy/privacy-policy.module').then(
        c => c.PrivacyPolicyModule
      )
  },
  {
    path: RoutePaths.PARTNERS,
    loadChildren: () =>
      import('./modules/partners/partners.module').then(
        c => c.PartnersModule
      )
  },
  {
    path: RoutePaths.GOOGLE_LANDING,
    component: NewRoofCostPageComponent,
  },
  {
    path: RoutePaths.COMPANY_ESTIMATOR,
    component: CompanyEstimatorPageComponent,
  },
  {
    path: RoutePaths.TERMS_AND_CONDITIONS,
    loadChildren: () =>
      import('./modules/terms-and-conditions/terms-and-conditions.module').then(
        c => c.TermsAndConditionsModule
      )
  },
  {
    path: RoutePaths.ESTIMATIONS,
    loadChildren: () =>
      import('./modules/estimations/estimations.module').then(
        c => c.EstimationsModule
      )
  },
  {
    path: RoutePaths.FCC,
    loadChildren: () =>
      import('./modules/fcc/fcc.module').then(
        c => c.FccModule
      )
  },
  {
    path: RoutePaths.NOT_FOUND,
    loadChildren: () =>
      import('./modules/not-found/not-found.module').then(
        c => c.NotFoundModule
      )
  },
  {
    path: '**', loadChildren: () =>
      import('./modules/not-found/not-found.module').then(
        c => c.NotFoundModule
      )
  }
];
